function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2013_27196)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 28.0511C50.0025 27.6981 49.8167 27.3695 49.5101 27.1849H49.5047L49.4854 27.1744L33.5459 17.9134C33.4771 17.8677 33.4056 17.826 33.3319 17.7884C32.7165 17.4768 31.9854 17.4768 31.37 17.7884C31.2963 17.826 31.2248 17.8677 31.156 17.9134L15.2165 27.1744L15.1973 27.1849C14.7101 27.4822 14.5607 28.1109 14.8637 28.5891C14.9529 28.73 15.0759 28.8473 15.2219 28.931L31.1614 38.192C31.2305 38.2373 31.3019 38.279 31.3754 38.317C31.9908 38.6287 32.7219 38.6287 33.3373 38.317C33.4108 38.279 33.4822 38.2373 33.5513 38.192L49.4908 28.931C49.8093 28.7488 50.0036 28.4129 50 28.0511Z",
  fill: "#0A2767"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.0747 21.8665H27.5349V31.2777H17.0747V21.8665ZM47.8605 12.3V7.99499C47.8856 6.91864 47.0176 6.02579 45.921 6H18.7767C17.6801 6.02579 16.8121 6.91864 16.8372 7.99499V12.3L32.8837 16.5L47.8605 12.3Z",
  fill: "#0364B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8372 12.3008H27.5349V21.7508H16.8372V12.3008Z",
  fill: "#0078D4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.2326 12.3008H27.5349V21.7508L38.2326 31.2008H47.8604V21.7508L38.2326 12.3008Z",
  fill: "#28A8EA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5349 21.75H38.2325V31.2H27.5349V21.75Z",
  fill: "#0078D4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5349 31.1992H38.2325V40.6492H27.5349V31.1992Z",
  fill: "#0364B8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.0747 31.2773H27.5349V39.8327H17.0747V31.2773Z",
  fill: "#14447D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.2325 31.1992H47.8604V40.6492H38.2325V31.1992Z",
  fill: "#0078D4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.51 28.8729L49.4897 28.8834L33.5501 37.6824C33.4806 37.7244 33.41 37.7643 33.3362 37.8C33.0654 37.9265 32.7714 37.998 32.4718 38.01L31.601 37.5102C31.5274 37.4739 31.456 37.4336 31.387 37.3894L15.2336 28.3406H15.2261L14.6976 28.0508V45.8629C14.7059 47.0513 15.6938 48.0083 16.9045 48.0007H47.8272C47.8454 48.0007 47.8615 47.9923 47.8807 47.9923C48.1364 47.9763 48.3886 47.9246 48.6295 47.839C48.7337 47.7957 48.8342 47.7445 48.9301 47.6857C49.0018 47.6458 49.1248 47.5587 49.1248 47.5587C49.6728 47.1607 49.9972 46.5321 49.9999 45.863V28.0508C49.9995 28.3915 49.8123 28.7056 49.51 28.8729Z",
  fill: "url(#paint0_linear_2013_27196)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M49.1442 27.9771V29.0691L32.4772 40.3325L15.2219 28.3446C15.2219 28.3388 15.2171 28.3341 15.2112 28.3341L13.6279 27.3996V26.6121L14.2805 26.6016L15.6605 27.3786L15.6926 27.3891L15.8102 27.4626C15.8102 27.4626 32.0279 36.5451 32.0707 36.5661L32.6911 36.9231C32.7446 36.9021 32.7981 36.8811 32.8623 36.8601C32.8944 36.8391 48.9623 27.9666 48.9623 27.9666L49.1442 27.9771Z",
  fill: "#0A2767"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.51 28.8729L49.4897 28.8845L33.5502 37.6835C33.4806 37.7255 33.41 37.7653 33.3362 37.8011C32.7172 38.0979 31.9933 38.0979 31.3743 37.8011C31.3009 37.7654 31.2296 37.7262 31.1603 37.6835L15.2208 28.8845L15.2016 28.8729C14.8938 28.7092 14.7009 28.3944 14.6977 28.0508V45.863C14.7054 47.0512 15.6929 48.0083 16.9035 48.0008C16.9035 48.0008 16.9035 48.0008 16.9036 48.0008H47.7941C49.0047 48.0084 49.9923 47.0512 50 45.8631C50 45.863 50 45.863 50 45.863V28.0508C49.9996 28.3915 49.8124 28.7056 49.51 28.8729Z",
  fill: "#1490DF"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M33.7823 37.5547L33.5437 37.6859C33.4746 37.7291 33.4032 37.7688 33.3298 37.8046C33.067 37.9312 32.7812 38.0054 32.489 38.023L38.5535 45.0622L49.1324 47.5643C49.4223 47.3494 49.6528 47.0668 49.8031 46.7422L33.7823 37.5547Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.05,
  d: "M34.8628 36.957L33.5437 37.6847C33.4746 37.7279 33.4032 37.7675 33.3298 37.8033C33.067 37.9299 32.7812 38.0042 32.489 38.0217L35.3302 45.7109L49.1356 47.5599C49.6794 47.1591 49.9996 46.5306 49.9999 45.8631V45.6331L34.8628 36.957Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.9335 48.0008H47.7909C48.2657 48.0032 48.7288 47.856 49.1121 47.5808L31.6 37.5124C31.5264 37.4761 31.455 37.4358 31.386 37.3916L15.2326 28.3427H15.2251L14.6977 28.0508V45.8021C14.6965 47.0153 15.6975 47.9996 16.9335 48.0008C16.9335 48.0008 16.9335 48.0008 16.9335 48.0008Z",
  fill: "#28A8EA"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.1,
  d: "M29.6744 16.3231V38.7196C29.6725 39.5048 29.186 40.2106 28.4441 40.5046C28.2143 40.6015 27.9668 40.6515 27.7167 40.6516H14.6976V15.4484H16.8372V14.3984H27.7167C28.7974 14.4025 29.672 15.2623 29.6744 16.3231Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M28.6047 17.3739V39.7704C28.6073 40.0241 28.5526 40.2751 28.4442 40.5054C28.1471 41.2242 27.4372 41.6957 26.647 41.6993H14.6976V15.4493H26.647C26.9574 15.4462 27.2633 15.5222 27.5349 15.6698C28.1907 15.9941 28.6044 16.6532 28.6047 17.3739Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M28.6046 17.3739V37.6704C28.5994 38.7307 27.7272 39.59 26.647 39.5992H14.6976V15.4493H26.6469C26.9573 15.4462 27.2632 15.5222 27.5348 15.6698C28.1906 15.9941 28.6044 16.6532 28.6046 17.3739Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M27.5349 17.3739V37.6703C27.5337 38.7323 26.6591 39.594 25.5772 39.5992H14.6976V15.4492H25.5772C26.659 15.4498 27.5355 16.311 27.5349 17.3728C27.5349 17.3732 27.5349 17.3735 27.5349 17.3739Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.96088 15.4492H25.574C26.657 15.4492 27.5349 16.3109 27.5349 17.3739V36.6245C27.5349 37.6875 26.657 38.5492 25.574 38.5492H5.96088C4.87791 38.5492 4 37.6875 4 36.6245V17.3739C4 16.3109 4.87793 15.4492 5.96088 15.4492Z",
  fill: "url(#paint1_linear_2013_27196)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.1287 23.5258C10.612 22.5152 11.3921 21.6694 12.3688 21.0972C13.4505 20.4894 14.682 20.1864 15.9279 20.2215C17.0826 20.1969 18.2221 20.4842 19.2217 21.052C20.1616 21.6022 20.9186 22.4083 21.4008 23.3725C21.926 24.435 22.1877 25.6043 22.1647 26.785C22.1901 28.019 21.9208 29.2416 21.3784 30.355C20.8847 31.3537 20.1037 32.1885 19.1319 32.7564C18.0937 33.3416 16.9119 33.6364 15.715 33.609C14.5356 33.6369 13.3711 33.3463 12.3485 32.769C11.4004 32.2181 10.6339 31.4111 10.1405 30.4443C9.61222 29.3971 9.34738 28.241 9.36811 27.0727C9.3461 25.8493 9.60611 24.6368 10.1287 23.5258ZM12.5164 29.2273C12.7741 29.8663 13.2111 30.4204 13.7766 30.8254C14.3526 31.2206 15.0424 31.4245 15.745 31.4071C16.4932 31.4362 17.2307 31.2254 17.846 30.8065C18.4044 30.4028 18.8299 29.8471 19.0698 29.2084C19.338 28.4951 19.4704 27.7395 19.4603 26.9793C19.4685 26.2118 19.3441 25.4484 19.0923 24.7218C18.8698 24.0657 18.458 23.4872 17.907 23.0565C17.3071 22.6178 16.5715 22.3953 15.8241 22.4265C15.1063 22.4082 14.4011 22.6137 13.8098 23.0134C13.2346 23.4202 12.7894 23.9792 12.526 24.6252C11.9418 26.1058 11.9388 27.7467 12.5175 29.2294L12.5164 29.2273Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.2325 12.3008H47.8604V21.7508H38.2325V12.3008Z",
  fill: "#50D9FF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2013_27196",
  x1: 32.3488,
  y1: 28.0508,
  x2: 32.3488,
  y2: 48.0008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#35B8F1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#28A8EA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_2013_27196",
  x1: 8.08849,
  y1: 13.9453,
  x2: 23.0207,
  y2: 40.2943,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1784D9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5,
  stopColor: "#107AD5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0A63C9"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2013_27196"
}, /*#__PURE__*/React.createElement("rect", {
  width: 46,
  height: 42,
  fill: "white",
  transform: "translate(4 6)"
})));

var SvgOutlook2021 = function SvgOutlook2021(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutlook2021, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outlook-2021.4e95be99.svg";
export { ForwardRef as ReactComponent };